import React, { useEffect, useState } from 'react';

import Icon from '../Icon/Icon';
import Button from '../Button/Button';

import { calculateTooltipPosition } from './lib/helpers';
import Hr from '../Hr/Hr';

//NOTE: Anchor selector (this must be reviewed for better performance and code quality)
const CustomTour = ({ steps, onClose }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [targetRect, setTargetRect] = useState(null);
  const step = steps[currentStepIndex];
  const position = step?.position;
  const isLastStep = currentStepIndex === steps.length - 1;

  useEffect(() => {
    const selector = steps?.[currentStepIndex]?.selector;
    if (!selector) {
      setTargetRect(null);
      return;
    }
    const el = document.querySelector(selector);
    setTargetRect(el ? el.getBoundingClientRect() : null);
    const onScrollOrResize = () => {
      if (!el) return;
      setTargetRect(el.getBoundingClientRect());
    };
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    return () => {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    };
  }, [currentStepIndex, steps]);

  const next = () => {
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex((i) => i + 1);
    } else {
      onClose();
    }
  };

  const prev = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex((i) => i - 1);
    }
  };

  if (!targetRect) return null;

  const tooltipPosition = calculateTooltipPosition(targetRect, position);

  const tooltipStyle = {
    position: 'fixed',
    top: tooltipPosition.top,
    left: tooltipPosition.left,
    zIndex: 999,
    background: 'white',
    borderRadius: 12,
    padding: '16px 20px',
    maxWidth: 358,
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
  };

  const highlightStyle = {
    position: 'fixed',
    top: targetRect.top - 1,
    left: targetRect.left - 1,
    width: targetRect.width + 1,
    height: targetRect.height + 1,
    boxSizing: 'border-box',
    zIndex: 998,
    pointerEvents: 'none',
    borderTopLeftRadius: isLastStep ? 0 : 12,
    borderTopRightRadius: isLastStep ? 0 : 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.4)',
  };

  return (
    <>
      <div style={highlightStyle} />
      <div style={tooltipStyle}>
        <div className="flex items-start justify-between gap-2">
          {step.title && <p className="text-sm font-semibold">{step.title}</p>}
          <button className="mt-0.5 shrink-0 cursor-pointer" onClick={onClose}>
            <Icon icon="close-linear" className="cursor-pointer" />
          </button>
        </div>
        <p className="mt-1 text-sm">{step.content}</p>
        <Hr className="my-4" />
        <div className="mt-3 flex items-center justify-between">
          <p className="text-xs text-neutral-500">
            {currentStepIndex + 1} of {steps.length}
          </p>
          <div className="flex items-center gap-3">
            {!isLastStep && (
              <button
                className="cursor-pointer text-xs text-neutral-500 hover:text-neutral-700"
                onClick={onClose}>
                Skip product tour
              </button>
            )}
            {currentStepIndex !== 0 && (
              <Button size="small" variant="link" text="Back" onClick={prev} />
            )}
            <Button
              transparent={!isLastStep}
              variant="primary"
              size="small"
              text={isLastStep ? 'Finish' : 'Next'}
              onClick={next}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomTour;
